export const SET_CHECKIN_PLACE_DISP = 'SET_CHECKIN_PLACE_DISP'
export const GET_CHECKIN_PLACE_DISP = 'GET_CHECKIN_PLACE_DISP'

export const SET_CHECKIN_HISTORY_DISP = 'SET_CHECKIN_HISTORY_DISP'
export const GET_CHECKIN_HISTORY_DISP = 'GET_CHECKIN_HISTORY_DISP'

export const SET_CHECKIN_HIS_DETAIL_DISP = 'SET_CHECKIN_HIS_DETAIL_DISP'
export const GET_CHECKIN_HIS_DETAIL_DISP = 'GET_CHECKIN_HIS_DETAIL_DISP'

export const SET_CHECKIN_DETAIL_DISP = 'SET_CHECKIN_DETAIL_DISP'
export const GET_CHECKIN_DETAIL_DISP = 'GET_CHECKIN_DETAIL_DISP'

export const TOGGLE_CHECKIN_PAGE = 'TOGGLE_CHECKIN_PAGE'

export const SET_CHECKIN_DROPDOWNS = 'SET_CHECKIN_DROPDOWNS'
export const GET_CHECKIN_DROPDOWNS = 'GET_CHECKIN_DROPDOWNS'
export const RECEIVED_CHECKIN_DROPDOWNS = 'RECEIVED_CHECKIN_DROPDOWNS'

export const SET_CHECKIN_COLUMNS = 'SET_CHECKIN_COLUMNS'
export const GET_CHECKIN_COLUMNS = 'GET_CHECKIN_COLUMNS'

export const SET_CHECKIN_LABELS = 'SET_CHECKIN_LABELS'
export const GET_CHECKIN_LABELS = 'GET_CHECKIN_LABELS'
export const RECEIVED_CHECKIN_COLUMNS_LABELS = 'RECEIVED_CHECKIN_COLUMNS_LABELS'

export const SET_CHECKIN_DATA_IN_RADIUS = 'SET_CHECKIN_DATA_IN_RADIUS'
export const GET_CHECKIN_DATA_IN_RADIUS = 'GET_CHECKIN_DATA_IN_RADIUS'
export const RECEIVED_CHECKIN_DATA_IN_RADIUS = 'RECEIVED_CHECKIN_DATA_IN_RADIUS'

export const SET_CHECKIN_HIS_SELECTED = 'SET_CHECKIN_HIS_SELECTED'
export const GET_CHECKIN_HIS_SELECTED = 'GET_CHECKIN_HIS_SELECTED'

export const SET_CHECKIN_PLACE = 'SET_CHECKIN_PLACE'
export const GET_CHECKIN_PLACE = 'GET_CHECKIN_PLACE'
export const RECEIVED_CHECKIN_PLACE = 'RECEIVED_CHECKIN_PLACE'
export const RECEIVED_CHECKIN_PLACE_NO_LOCATION = 'RECEIVED_CHECKIN_PLACE_NO_LOCATION'

export const SET_CHECKIN_PLACE_NEW_LATLNG = 'SET_CHECKIN_PLACE_NEW_LATLNG'
export const GET_CHECKIN_PLACE_NEW_LATLNG = 'GET_CHECKIN_PLACE_NEW_LATLNG'

export const SET_CHECKIN_RADIUS = 'SET_CHECKIN_RADIUS'
export const GET_CHECKIN_RADIUS = 'GET_CHECKIN_RADIUS'

export const SET_CHECKIN_HISTORY = 'SET_CHECKIN_HISTORY'
export const GET_CHECKIN_HISTORY = 'GET_CHECKIN_HISTORY'
export const RECEIVED_CHECKIN_HISTORY = 'RECEIVED_CHECKIN_HISTORY'

export const SET_CHECKIN_DETAIL = 'SET_CHECKIN_DETAIL'
export const GET_CHECKIN_DETAIL = 'GET_CHECKIN_DETAIL'
export const RECEIVED_CHECKIN_DETAIL = 'RECEIVED_CHECKIN_DETAIL'

export const SET_CHECKIN_DETAIL_SELECTED = 'SET_CHECKIN_DETAIL_SELECTED'
export const GET_CHECKIN_DETAIL_SELECTED = 'GET_CHECKIN_DETAIL_SELECTED'

export const SET_LAST_CHECKIN = 'SET_LAST_CHECKIN'
export const GET_LAST_CHECKIN = 'GET_LAST_CHECKIN'
export const RECEIVED_LAST_CHECKIN = 'RECEIVED_LAST_CHECKIN'

export const SAVE_CHECKIN = 'SAVE_CHECKIN'
export const SAVE_CHECKIN_DETAIL = 'SAVE_CHECKIN_DETAIL'

export const SET_CHECKIN_NEW_LAT_LNG_SELECTED = 'SET_CHECKIN_NEW_LAT_LNG_SELECTED'
export const GET_CHECKIN_NEW_LAT_LNG_SELECTED = 'GET_CHECKIN_NEW_LAT_LNG_SELECTED'

export const GET_CHECKIN_PATH_IMAGE = 'GET_CHECKIN_PATH_IMAGE'
export const SET_CHECKIN_PATH_IMAGE = 'SET_CHECKIN_PATH_IMAGE'

export const SAVE_CHECKIN_LOG = 'SAVE_CHECKIN_LOG'

export const START_FLG_LOADING = 'START_FLG_LOADING'
export const STOP_FLG_LOADING = 'STOP_FLG_LOADING'
export const SET_FLG_LOADING = 'SET_FLG_LOADING'
export const GET_FLG_LOADING = 'GET_FLG_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/hres6oe/mutation-types.js